import { FormationComponent } from './components/formation/formation.component';
import { ProfileInformationsComponent } from './components/profile-informations/profile-informations.component';
import { DevisListComponent } from './components/devis-list/devis-list.component';
import { FactureListComponent } from './components/facture-list/facture-list.component';
import { Routes } from '@angular/router';
import { AuthorizedIntervenantGuard } from './guards/authorized-intervenant.guard';
import { ProfileComponent } from './components/profile/profile.component';
import { SatisfactionFormComponent } from './components/satisfaction-form/satisfaction-form.component';
import { SessionListComponent } from './components/session/session-list/session-list.component';
import { SessionViewComponent } from './components/session/session-view/session-view.component';

export const AccountRouting: Routes = [
  {
    path: '',
    component: ProfileComponent
  },
  {
    path: 'homepage',
    component: ProfileComponent
  },
  {
    path: 'mesformations/:id', //todo session or parcours ?
    component: FormationComponent
  },
  {
    path: 'mespropositionscommerciales',
    component: DevisListComponent
  },
  {
    path: 'mesfactures',
    component: FactureListComponent
  },
  {
    path: 'mesinformations',
    component: ProfileInformationsComponent
  },
  {
    path: 'satisfaction',
    component: SatisfactionFormComponent
  },
  {
    path: 'sessions',
    component: SessionListComponent
  },
  {
    path: 'sessions/ficheSession/:idSession',
    component: SessionViewComponent,
    canActivate: [AuthorizedIntervenantGuard]
  }
];
